export default {
  getNextAlert(state) {
    return state.nextStaffAlert;
  },
  getAllAlerts(state) {
    return state.staffAlerts;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/alerts/getters.js